export default __webpack_public_path__ + "static/media/list-icon.735bf71a.svg";